import React from "react";
import { Box, Skeleton, Paper } from "@mui/material";

const CampaignTableSkeleton: React.FC = () => {
  return (
    <Paper elevation={0} sx={{ border: "1px solid #EAECF0", mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          p: 2,
          borderBottom: "1px solid #EAECF0",
          background: "#f8f9fa",
        }}
      >
        {Array.from({ length: 9 }).map((_, i) => (
          <Skeleton
            key={i}
            variant="text"
            width={i === 0 ? "5%" : "10%"}
            height={24}
            sx={{ mx: 1 }}
          />
        ))}
      </Box>

      {Array.from({ length: 8 }).map((_, row) => (
        <Box
          key={row}
          sx={{
            display: "flex",
            p: 2,
            borderBottom: "1px solid #EAECF0",
            background: row % 2 === 0 ? "#ffffff" : "#F9FAFB",
          }}
        >
          {Array.from({ length: 9 }).map((_, col) => (
            <Skeleton
              key={`${row}-${col}`}
              variant={col === 2 ? "rectangular" : "text"}
              width={col === 0 ? "5%" : "10%"}
              height={col === 2 ? 22 : 24}
              sx={{ mx: 1, borderRadius: col === 2 ? 4 : 0 }}
            />
          ))}
        </Box>
      ))}

      <Box sx={{ display: "flex", justifyContent: "space-between", p: 2 }}>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Skeleton
            variant="rectangular"
            width={80}
            height={32}
            sx={{ borderRadius: 1 }}
          />
          <Skeleton
            variant="rectangular"
            width={80}
            height={32}
            sx={{ borderRadius: 1 }}
          />
        </Box>
        <Skeleton variant="text" width={60} height={32} />
      </Box>
    </Paper>
  );
};

export default CampaignTableSkeleton;
